import type { TOC } from '@ember/component/template-only';
import { or } from 'ember-truth-helpers';
import SettingsCentralMappingDropdownsDropdownBarBased from 'lumen/components/settings/central-mapping/dropdowns/dropdown-bar-based';
import { TRIGGER_CENTRAL_MAPPING_VARIANTS } from 'lumen/components/settings/central-mapping/dropdowns/triggers/trigger-central-mapping';
import type { CentralMappingMappingEntryMarketSegment } from 'lumen/models';
import type { BarBased } from 'lumen/models/central-mapping/mapping-entry-market-segment';

interface HotelSettingsCentralMappingTablesCellsTdBarBasedSignature {
  Args: {
    column: {
      isReadOnly?: boolean;
    };
    row: {
      mappingEntry: CentralMappingMappingEntryMarketSegment;
      setBarBased: (value: BarBased) => void;
    };
    rowMeta: {
      isSelected: boolean;
    };
  };
}

const HotelSettingsCentralMappingTablesCellsTdBarBased: TOC<HotelSettingsCentralMappingTablesCellsTdBarBasedSignature> =
  <template>
    <div data-test-id="table-central-mapping-td-bar-based">
      <SettingsCentralMappingDropdownsDropdownBarBased
        @autoBarBased={{@row.mappingEntry.autoBarBased}}
        @barBased={{@row.mappingEntry.barBased}}
        @isReadOnly={{or @column.isReadOnly @rowMeta.isSelected}}
        @isSelected={{@rowMeta.isSelected}}
        @setBarBased={{@row.setBarBased}}
        @userBarBased={{@row.mappingEntry.userBarBased}}
        @variant={{TRIGGER_CENTRAL_MAPPING_VARIANTS.SUBDUED}}
      />
    </div>
  </template>;

export default HotelSettingsCentralMappingTablesCellsTdBarBased;
